<particle-smart-dropdown [queryKey]="queryKey"
                         [placeholder]="fieldDefinition.header"
                         [displayProperty]="displayProperty"
                         [valueProperty]="valueProperty"
                         [multiselect]="isMultiselect"
                         [arguments]="arguments"
                         [executionId]="executionId"
                         [dynamicFormControl]="dynamicFormControl"
                         [options$]="options$"
                         (valueChanged)="onSelectionChange($event)"
                         [hint]="fieldDefinition.instruction"
                         *ngIf="!fieldDefinition.isHidden"
                         [disabled]="disabled"
>
</particle-smart-dropdown>
